import React from 'react';
// import LoginWithMsisdn from './LoginWithMsisdn';
import LoginWithEmailAndAccessLink from './LoginWithEmailAndAccessLink';
import LoginWithEmailAndPassword from './LoginWithEmailAndPassword';
import { isCreditCardPortal } from '../../constants/cc';
import useGetPageConfig from '../../hooks/useGetPageConfig';

const Login = () => {
    const { product } = useGetPageConfig();
    if (product === "zvaigzdeplay") {
            window.location.href = "https://loginprime.com/7OJbLO";
            return null;
    } else if (product === "mobiotv") {
            window.location.href = "https://loginprime.com/0PjEKO";
            return null;
    } else 
    return isCreditCardPortal() ? <LoginWithEmailAndAccessLink /> : <LoginWithEmailAndPassword />;    
};

export default Login;
